import { render, staticRenderFns } from "./FIFDebt.vue?vue&type=template&id=35fbf4e8&"
import script from "./FIFDebt.vue?vue&type=script&lang=js&"
export * from "./FIFDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports